import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {NgControl} from '@angular/forms';
import {ValidationService} from '../services/validation.service';

@Directive({
  selector: '[codes]'
})
export class PostCodesDirective implements AfterViewInit, OnDestroy {
  @Input() codes;
  sub;

  constructor(public control: NgControl) {
  }

  setCity(value) {
    const parent = this.control.control.parent;
    const {postCodes} = this.codes;
    if(postCodes) {
      const {cities} = postCodes.find(item => item.value === value);
      if (cities.length === 1) {
        parent.get(`cityName`).patchValue(cities[0].label);
      } else if(cities.length === 0) {
        parent.get(`cityName`).patchValue(null);
      }
    }
  }

  ngAfterViewInit() {
    const selectedCode = this.control.control.value;
    if(selectedCode) {
      this.setCity(selectedCode);
    }
    this.sub = this.control.control.valueChanges.subscribe(value => {
      if (value) {
        this.setCity(value);
        // const city = cities.find(item => parseInt(item.value) === parseInt(value))?.label;
        // parent.get(`city`).patchValue(city);
        /*const region = postCodes.find(item => item.value === value)?.label;
        const city = postCodes.find(item => item.value === value)?.forId;
        const cityControl = parent.get(`city`);
        if (!cityControl.disabled) {
          parent.get(`city`).patchValue(city);
        }
        parent.parent.get(`region`).patchValue(region);*/
      }
    });
  }

  ngOnDestroy() {
    if(this.sub){
      this.sub.unsubscribe();
    }
  }

}
